import { Injector } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable, of } from 'rxjs';
import { filter, take, timeout } from 'rxjs/operators';
import { FreidaRoles } from '../enums';
import { UserModel } from '../models';
import { UserLookupState, UserService } from '../services/user.service';

const USER_LOOKUP_TIMEOUT_MS = 10000;

/**
 * Emits once with the settled result of the shared roles lookup (`UserService.currentUserRoles`).
 * Always emits — errors and timeouts arrive as `error`, never as an empty completion — so a route
 * guard built on it cannot make the router skip the route and fall through to the 404 page.
 */
export function awaitUserLookup(userService: UserService, injector: Injector): Observable<UserLookupState> {
  userService.refreshJwtUid();
  return toObservable(userService.currentUserLookup, { injector }).pipe(
    filter((state) => state.settled),
    take(1),
    timeout({
      first: USER_LOOKUP_TIMEOUT_MS,
      with: () => of<UserLookupState>({ settled: true, user: null, error: new Error('User lookup timed out'), recoveredFromJwt: false }),
    }),
  );
}

export function isMemberOrAuthenticated(user: UserModel | null): boolean {
  const roles = user?.roles ?? [];
  return roles.includes(FreidaRoles.AmaMemberRole) || roles.includes('AMA Member') || roles.includes('authenticated');
}
